export enum SeoEnum {
  home,
  comefunziona,
  aziende,
  annunci,
  registrazione,
  welcome,
}
